import { useState } from 'react'

export const useDealId = (): number | undefined => {
  const [dealId] = useState<number | undefined>(() => {
    try {
      // sessionStorage is tab-specific and survives refresh — avoids cross-tab dealId pollution.
      const dealIdFromStorage = sessionStorage.getItem('dealId')

      if (!dealIdFromStorage) {
        return undefined
      }

      const parsedDealId = parseInt(dealIdFromStorage, 10)

      if (isNaN(parsedDealId) || parsedDealId <= 0) {
        console.warn('Invalid dealId in storage:', dealIdFromStorage)
        return undefined
      }

      return parsedDealId
    } catch (error) {
      console.error('Error reading dealId from storage:', error)
      return undefined
    }
  })

  return dealId
}
